module.exports = __webpack_public_path__ + "img/clouds.15f0e0d5.png";